import Vue from 'vue'
import Router from 'vue-router'
import SearchView from '@/pages/search/search-view'
import SearchAdd from '@/pages/search/search-add'

import ReportIndex from '@/pages/report/report-index'

import Dashboard from '@/pages/dashboard'
import Login from '@/pages/login'
import Error from '@/pages/error'
import Register from '@/pages/register'
import Profile from '@/pages/profile'
import * as auth from '@/services/auth'
import store from '@/store/index'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/tracking/add',
      name: 'search-add',
      component: SearchAdd
    },
    {
      path: '/tracking/:id',
      name: 'search-view',
      component: SearchView
    },
    {
      path: '/reports',
      name: 'report-index',
      component: ReportIndex
    },
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        layout: 'centered',
        anonymous: true
      }
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: {
        layout: 'centered',
        anonymous: true
      }
    },
    {

      path: '/profile',
      name: 'profile',
      component: Profile
    },
    {
      path: '/:anything',
      name: 'error',
      component: Error
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (typeof to.meta.layout !== 'undefined') {
    store.commit('pages/setLayout', to.meta.layout)
  } else {
    store.commit('pages/setLayout', 'default')
  }

  // authentication
  if (!auth.getUser() && to.meta.anonymous !== true) {
    next({ name: 'login' })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js